import { render, staticRenderFns } from "./suoritemerkinta-form.vue?vue&type=template&id=4ec7fa17&scoped=true&"
import script from "./suoritemerkinta-form.vue?vue&type=script&lang=ts&"
export * from "./suoritemerkinta-form.vue?vue&type=script&lang=ts&"
import style0 from "./suoritemerkinta-form.vue?vue&type=style&index=0&id=4ec7fa17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7fa17",
  null
  
)

export default component.exports